import * as angular from 'angular';

export interface StorageFcfsOfferResource
    extends ng.resource.IResourceClass<
        ng.resource.IResource<StorageFcfsOfferDto>
    > {
    getAttachments: ng.resource.IResourceMethod<
        ng.resource.IResource<DocumentDto>
    >;
}

function storageFcfsOfferResource(
    $resource: ng.resource.IResourceService,
    API_URL
): StorageFcfsOfferResource {
    return <StorageFcfsOfferResource>$resource(
        API_URL.STORAGE_FCFS_OFFER,
        {},
        {
            getAttachments: {
                method: 'GET',
                url: API_URL.STORAGE_FCFS_OFFER + '/:id/attachment',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory('storageFcfsOfferResource', storageFcfsOfferResource);
